import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OemMenuService, QUORUM_API_BASE } from './oem-menu.service';
import { OemIntegrationService, QUORUM_API_BASE_OEM } from './oem-integration.service';
import { HttpClientModule } from '@angular/common/http';
import { IntegrationService, QUORUM_API_BASE_INTEGRATION } from './integration.service';

@NgModule({
  imports: [CommonModule, HttpClientModule],
  providers: [OemMenuService, OemIntegrationService, IntegrationService],
})
export class QuorumApiModule {
  static withConfig(options: QuorumApiModuleOptions): ModuleWithProviders<QuorumApiModule> {
    return {
      ngModule: QuorumApiModule,
      providers: [
        {
          provide: QUORUM_API_BASE,
          useValue: options.quorumApiBase,
        },
        {
          provide: QUORUM_API_BASE_OEM,
          useValue: options.quorumApiBase,
        },
        {
          provide: QUORUM_API_BASE_INTEGRATION,
          useValue: options.quorumApiBase,
        },
      ],
    };
  }
}

export interface QuorumApiModuleOptions {
  quorumApiBase: string;
}
